import { render, staticRenderFns } from "./BotaoSalvarAvancar.vue?vue&type=template&id=64161f53&scoped=true"
import script from "./BotaoSalvarAvancar.vue?vue&type=script&lang=js"
export * from "./BotaoSalvarAvancar.vue?vue&type=script&lang=js"
import style0 from "./BotaoSalvarAvancar.vue?vue&type=style&index=0&id=64161f53&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64161f53",
  null
  
)

export default component.exports